/**
 * @license
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://raw.githubusercontent.com/l-lin/angular-datatables/master/LICENSE
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataTableDirective } from './angular-datatables.directive';
var DataTablesModule = (function () {
    function DataTablesModule() {
    }
    DataTablesModule.forRoot = function () {
        return {
            ngModule: DataTablesModule
        };
    };
    return DataTablesModule;
}());
export { DataTablesModule };
DataTablesModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule],
                declarations: [DataTableDirective],
                exports: [DataTableDirective]
            },] },
];
/** @nocollapse */
DataTablesModule.ctorParameters = function () { return []; };
//# sourceMappingURL=angular-datatables.module.js.map


//////////////////
// WEBPACK FOOTER
// /var/www/html/LASO/laso-client/node_modules/angular-datatables/src/angular-datatables.module.js
// module id = ../../../../angular-datatables/src/angular-datatables.module.js
// module chunks = vendor